import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { OauthComponent } from 'app/modules/oauth/oauth.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboards/summary'
    {path: '', pathMatch : 'full', redirectTo: 'dashboards/summary'},

    // Redirect signed-in user to the '/dashboards/summary'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboards/summary'},

    // Oauth routes
    {
        path: '',
        component: OauthComponent,
        data: {
            layout: 'empty'
        },
        children: [            
            // Oauth
            {path: 'oauth', children: [
                {path: 'authorization', loadChildren: () => import('app/modules/oauth/authorization/authorization.routes')},
                {path: 'authentication', loadChildren: () => import('app/modules/oauth/authentication/authentication.routes')}
            ]},
        ]
    },    

    // Error routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [            
            // Error
            {path: 'error', children: [
                {path: '400', loadChildren: () => import('app/modules/error/error-400/error-400.routes')},
                {path: '404', loadChildren: () => import('app/modules/error/error-404/error-404.routes')},
                {path: '500', loadChildren: () => import('app/modules/error/error-500/error-500.routes')}
            ]},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            // Dashboard
            {path: 'dashboards', children: [
                {path: 'summary', loadChildren: () => import('app/modules/admin/dashboards/summary/summary.routes')},
            ]},
            // Apps
            {path: 'apps', children: [
                {path: 'customers', loadChildren: () => import('app/modules/admin/apps/clientes/clientes.routes')},
                {path: 'rewards', loadChildren: () => import('app/modules/admin/apps/recompensas/recompensas.routes')},
                {path: 'bonuses', loadChildren: () => import('app/modules/admin/apps/bonificaciones/bonificaciones.routes')},
                {path: 'periods', loadChildren: () => import('app/modules/admin/apps/periodos/periodos.routes')},
            ]},

            // Pages
            {path: 'pages', children: [
                {path: 'settings', loadChildren: () => import('app/modules/admin/pages/settings/settings.routes')},
            ]},

            {path: 'example', loadChildren: () => import('app/modules/admin/example/example.routes')},
        ]
    }

    



];
